import { useNetwork as useNetworkFn } from './UseNetwork';

const useNetwork = useNetworkFn;

export default useNetwork;
